angular.module('app.supplyChain')

.controller('supplierScorecardCtrl', function ($scope, $rootScope, $timeout, $filter, $sce, $window, currencyFormatService, leanFilterService, numberFormatService,
	percentageFormatService, scorecardServ, a3ModalService, storeService, scorecardServ, $experiments, drilldownFunctionsService, leanTableConfigService) {
	var vm = this;
	vm.scorecardData = {};
	vm.siteNdxByName = {};
	vm.isSavedReport = false;
	vm.isSavedReport = false;
	vm.leanFilterService = leanFilterService;
	vm.supplierPortalView = globalConfig.user.role === 'Supplier';
	vm.sendByEmail = sendByEmail;
	vm.hideSupplierCode = true;
	vm.authorize = $rootScope.authorize;
	vm.isSupplyOrdersReactReport = true;
	vm.hideOptions = true;
	var formatMap = { 'percent': percentageFormatService.getWithParameters, 'number': numberFormatService.getWithParameters };
	var erpOrderPolicyList = [];

	function zonedTimeToUtc(timestamp) {
		var tMoment = moment(timestamp);
		return tMoment.add(tMoment.utcOffset(), 'minutes').unix() * 1000;
	}

	function getStartDateFromType(type) {
		if (type == 'rollingAvg')
			return moment(vm.scorecardData.dataAnalysisStartDateRaw).unix() * 1000;
		if (type == 'month1')
			return moment(vm.scorecardData.month1Start).unix() * 1000;
		if (type == 'month2')
			return moment(vm.scorecardData.month2Start).unix() * 1000;
		if (type == 'month3')
			return moment(vm.scorecardData.month3Start).unix() * 1000;
	}

	function getEndDateFromType(type) {
		if (type == 'rollingAvg')
			return moment(vm.scorecardData.month3End).unix() * 1000;
		if (type == 'month1')
			return moment(vm.scorecardData.month1End).unix() * 1000;
		if (type == 'month2')
			return moment(vm.scorecardData.month2End).unix() * 1000;
		if (type == 'month3')
			return moment(vm.scorecardData.month3End).unix() * 1000;
	}

	function getEndMonthDate(startDate) {
		return new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
	}

	var comparatorMap = {
		'le': '&le;',
		'lt': '&lt;',
		'ge': '&ge;',
		'gt': '&gt;',
		'eq': '='
	};

	// Allow suppliers to drill into all metrics except cost
	vm.authorizeLink = function(metric) {
		if ((metric.indexOf('Cost') > -1) && vm.supplierPortalView)
			return false;
		if ((metric.indexOf('VMI') > -1) && vm.supplierPortalView)
			return false;
		if ((metric.indexOf('MinMax') > -1) && vm.supplierPortalView)
			return false;
		if ((metric.indexOf('Quality') > -1) && vm.supplierPortalView)
			return false;
		return true;
	};

	vm.getDrilldownLink = function(metric, type, factoryNdx, supplierNdx) {
		var drilldownSupplierNdx = supplierNdx || (factoryNdx !== undefined ? vm.factorySupplierMap[factoryNdx] : $scope.supplierNdxs);
		var drilldownFactoryNdx = factoryNdx !== undefined ? factoryNdx : $scope.leanDirFactoryNdxs.split(',');
		if (metric.indexOf('Cost') > -1) {
			var startMonth = type === 'rollingAvg' ? vm.scorecardData.dataAnalysisStartDateRaw : vm.scorecardData[type + 'Start'];
			return '/application/f/home.html#/supply-chain/spend-analytics/item-spend/?drilldown=1&' + 'supplierNdx=' + drilldownSupplierNdx + '&supplierName=' + vm.scorecardData.supplierName + '&startMonth=' + startMonth + '&factory=' + drilldownFactoryNdx;
		}
		if (metric.indexOf('Quality') > -1) {
			return '/application/f/home.html#/supply-chain/supplier-quality?drilldown=1&' + 'supplierNdx=' + drilldownSupplierNdx + '&startDate=' + getStartDateFromType(type) + '&endDate=' + getEndDateFromType(type) + '&factory=' + drilldownFactoryNdx;
		}
		if (metric.indexOf('MinMax') > -1) {
			if (vm.supplierPortalView) {
				return '';
			}
			var factoryValues = Array.isArray(drilldownFactoryNdx) ? drilldownFactoryNdx : [drilldownFactoryNdx];
			var erpOrderPolicies = [];
			if (erpOrderPolicyList && erpOrderPolicyList.length) {
				erpOrderPolicyList.forEach(function(erpOrderPolicy) {
					if (erpOrderPolicy.orderPolicy === 'MinMax') {
						vm.leanFilterService.escapeCommasForOrderPolicies(erpOrderPolicies, erpOrderPolicy);
					}
				});
			}
			var filters = [
				drilldownFunctionsService.makeSelectFilter('supplierNdx', drilldownSupplierNdx),
				drilldownFunctionsService.makeSelectFilter('erpOrderPolicy', erpOrderPolicies),
				drilldownFunctionsService.makeSelectFilter('factory', factoryValues)
			];
			filters.push(drilldownFunctionsService.makeRangeFilter('dateLog', leanFilterService.comparatorsMap.between,
				zonedTimeToUtc(getStartDateFromType(type)), zonedTimeToUtc(getEndDateFromType(type))));
			var sorters = [{ property: 'dateLog', direction: 'DESC' }];
			return '/application/f/home.html#/supply-chain/procurement-history' +
				drilldownFunctionsService.makeDrilldownParamString(filters, false, sorters);
		}
		if (metric.indexOf('Delivery') > -1) {
			var status = 'Early,Late,OnTime,NotDeliveredYetPastDue,NotDeliveredYet';
			if (metric.indexOf('Late') > -1) {
				status = 'Late,OnTime,NotDeliveredYetPastDue,NotDeliveredYet';
			} else if (metric.indexOf('Early') > -1) {
				status = 'Early,OnTime';
			}
			var erpOrderPolicies = [];
			if (erpOrderPolicyList && erpOrderPolicyList.length) {
				erpOrderPolicies = [];
				erpOrderPolicyList.forEach(function(erpOrderPolicy) {
					if (erpOrderPolicy.orderPolicy !== 'MinMax' && erpOrderPolicy.orderPolicy !== 'Kanban') {
						vm.leanFilterService.escapeCommasForOrderPolicies(erpOrderPolicies, erpOrderPolicy);
					}
				});
			}
			var sorters = [{ property: 'scorecardDate', direction: 'DESC' }];
			var filters = [
				{ id: 'supplierNdx', values: [drilldownSupplierNdx] },
				{ id: 'erpOrderPolicy', values: erpOrderPolicies },
				{ id: 'deliveryStatus', values: leanTableConfigService.translateDeliveryStatusCode(status) },
				{ id: 'responsibleNdx', values: []},
				{ id: 'factory', values: Array.isArray(drilldownFactoryNdx) ? drilldownFactoryNdx : [drilldownFactoryNdx] },
				{ id: 'deliveryScoreGroupingDate', comparator: 'Between', valueOne: zonedTimeToUtc(getStartDateFromType(type)), valueTwo: zonedTimeToUtc(getEndDateFromType(type)) }];
			return 'home.html#/supply-chain/purchase-orders/' + drilldownFunctionsService.makeDrilldownParamString(filters, true, sorters);
		}

		return '';
	};

	vm.getSupplyOrdersDrilldownUrl = function(supplierNdxs, factoryNdxs) {
		var supplyOrdersUrl = '/application/f/home.html#/supply-chain/supply-orders';
		var drilldownFilters = [
			drilldownFunctionsService.makeSelectFilter('factory', [factoryNdxs]),
			drilldownFunctionsService.makeSelectFilter('supplierNdx', [supplierNdxs]),
			drilldownFunctionsService.makeRangeFilter('remainingQuantityFloat', leanFilterService.comparatorsMap.greaterThan, 0)
		];
		return supplyOrdersUrl + drilldownFunctionsService.makeDrilldownParamString(drilldownFilters, false, null);
	};

	function getTooltipHtml(metric) {
		var name = metric.name;
		if (name === 'Quality Performance')
			name = name + ' (DPPM)';
		var greenStatus = 'Value ' + comparatorMap[metric.goodComparator] + ' ' + formatMap[metric.format](metric.goodThreshold);
		var warnStatus = 'Value ' + comparatorMap[metric.warnComparator] + ' ' + formatMap[metric.format](metric.warnThreshold);
		var badStatus = 'Value ' + comparatorMap[metric.badComparator] + ' ' + formatMap[metric.format](metric.badThreshold);
		var html = '<div class="myTooltip">' +
			'<div class="tooltipHeader">' + name + '</div>' +
			'<div class="tooltipBody">' +
			'<ul>' +
			'<li>' +
			'<span><i class="fa fa-fw fa-circle good small-circle"></i></span>' +
			'<span>' + greenStatus + '</span>' +
			'</li>' +
			'<li>' +
			'<span><i class="fa fa-fw fa-circle warn small-circle"></i></span>' +
			'<span>' + warnStatus + '</span>' +
			'</li>' +
			'<li>' +
			'<span><i class="fa fa-fw fa-circle bad small-circle"></i></span>' +
			'<span>' + badStatus + '</span>' +
			'</li>' +
			'</ul>' +
			'</div>' +
			'</div>';
		return $sce.trustAsHtml(html);
	};

	function processScorecardResponse(data) {
		if (data) {
			var metadata = data.metadata;
			var scores = data.scores;
			var currencySymbol = data.currencySymbol;
			if (metadata) {
				vm.scorecardData.dataAnalysisStartDateRaw = metadata.dataAnalysisStartDate;
				vm.scorecardData.dataAnalysisStartDate = $filter('date')(metadata.dataAnalysisStartDate, 'mediumDate', 'UTC');
				vm.scorecardData.inventoryOnHand = currencyFormatService.getWithParameters(metadata.onHand, 0, currencySymbol);
				vm.scorecardData.inventoryOnOrder = currencyFormatService.getWithParameters(metadata.onOrder, 0, currencySymbol);
				vm.scorecardData.supplierSpend = currencyFormatService.getWithParameters(metadata.spend, 0, currencySymbol);
				vm.scorecardData.supplierSpendPreviousFiscalYear = currencyFormatService.getWithParameters(metadata.spendPreviousFiscalYear, 0, currencySymbol);
				var dateTmp = new Date();
				dateTmp.setMonth(metadata.month1 - 1, 15);
				dateTmp.setYear(metadata.month1year);
				vm.scorecardData.month1Name = $filter('date')(dateTmp, 'MMM', 'UTC');
				vm.scorecardData.month1Start = $filter('date')(dateTmp, 'yyyy-MM-01');
				vm.scorecardData.month1End = $filter('date')(getEndMonthDate(dateTmp), 'yyyy-MM-dd');
				dateTmp.setMonth(metadata.month2 - 1, 15);
				dateTmp.setYear(metadata.month2year);
				vm.scorecardData.month2Name = $filter('date')(dateTmp, 'MMM', 'UTC');
				vm.scorecardData.month2Start = $filter('date')(dateTmp, 'yyyy-MM-01');
				vm.scorecardData.month2End = $filter('date')(getEndMonthDate(dateTmp), 'yyyy-MM-dd');
				dateTmp.setMonth(metadata.month3 - 1, 15);
				dateTmp.setYear(metadata.month3year);
				vm.scorecardData.month3Name = $filter('date')(dateTmp, 'MMM', 'UTC');
				vm.scorecardData.month3Start = $filter('date')(dateTmp, 'yyyy-MM-01');
				vm.scorecardData.month3End = $filter('date')(getEndMonthDate(dateTmp), 'yyyy-MM-dd');
				vm.scorecardData.month1LogDate = moment.utc(metadata.month1logdate).unix() * 1000;
				vm.scorecardData.month2LogDate = moment.utc(metadata.month2logdate).unix() * 1000;
				vm.scorecardData.month3LogDate = moment.utc(metadata.month3logdate).unix() * 1000;
				if (metadata.deliveryScoreComputationMethod === 'quantity')
					vm.deliveryScoreComputationMethodDesc = ' percent of the of parts were delivered ';
				else if (metadata.deliveryScoreComputationMethod === 'count')
					vm.deliveryScoreComputationMethodDesc = ' percent of the deliveries were ';
				else if (metadata.deliveryScoreComputationMethod === 'value')
					vm.deliveryScoreComputationMethodDesc = ' percent of the value of delivered parts was delivered ';
				else
					vm.deliveryScoreComputationMethodDesc = ' percent was delivered ';

			}
			if (scores) {
				for (var i = 0; i < scores.length; i++) {
					var legend = getTooltipHtml(scores[i]);
					var met = scores[i];
					met.legend = legend;
					var data = met.data;
					if (met.data) {
						for (var j = 0; j < data.length; j++) {
							var site = data[j];
							site.showLink = true;//;
							var factoryNdxs = site.factoryNdx.split(',');
							if(factoryNdxs.length > 1) {
								site.factoryNdx = [];
								for(var k = 0; k < factoryNdxs.length; k++) {
									site.factoryNdx.push(parseInt(factoryNdxs[k]));
								}
							} else {
								site.factoryNdx = parseInt(factoryNdxs[0]);
							}
							if (site.rollingAvg) {
								site.rollingAvg.rawValue = site.rollingAvg.value;
								site.rollingAvg.value = formatMap[met.format](site.rollingAvg.value);
							}
							if (site.month1) {
								site.month1.rawValue = site.month1.value;
								site.month1.value = formatMap[met.format](site.month1.value);
							}
							if (site.month2) {
								site.month2.rawValue = site.month2.value;
								site.month2.value = formatMap[met.format](site.month2.value);
							}
							if (site.month3) {
								site.month3.rawValue = site.month3.value;
								site.month3.value = formatMap[met.format](site.month3.value);
							}
						}
					}
				}
			}
			vm.scorecardData.scoreCategories = scores;
		}
	}

	function loadErpOrderPolicyData() {
		scorecardServ.getErpOrderPolicyData($scope.leanDirFactoryNdxs)
			.then(function(data) {
				erpOrderPolicyList = data;
			});
	}

	function setSiteNdxBySiteName() {
		angular.forEach(globalConfig.user.authFacts, function(site) {
			vm.siteNdxByName[site.name] = site.ndx;
		});
	}

	function sendByEmail() {
		if ($scope.supplierNdxs) {
			var supplierNdxList = $scope.supplierNdxs.toString().split(',');
			var factoryNdxList = $scope.leanDirFactoryNdxs.toString().split(',');
			var showAllSites = false;
			if (supplierNdxList.length > 1 || factoryNdxList.length > 1) {
				showAllSites = true;
			}
			scorecardServ.sendEmail(supplierNdxList[0], showAllSites, factoryNdxList[0]).then(function(response) {
				if (response) {
					$rootScope.$emit('toast', {
						'message': 'You will receive the email in the next few minutes.',
						'success': true,
						'time': 3000
					});
				}
			});
		}
	};

	function init() {
		loadErpOrderPolicyData();
		setSiteNdxBySiteName();
		var supplierNdxList = $scope.supplierNdxs.toString().split(',');
		var factoryNdxList = $scope.leanDirFactoryNdxs.toString().split(',');
		vm.factorySupplierMap = {};
		for (var i = 0; i < factoryNdxList.length; i++) {
			vm.factorySupplierMap[factoryNdxList[i]] = supplierNdxList[i];
		}

		if (supplierNdxList.length > 1 || factoryNdxList.length > 1) {
			vm.hideEmail = true;
			scorecardServ.getScorecardDataBySupplierCode($scope.supplierCode, $scope.leanDirFactoryNdxs,
				$scope.supplierNdxs).then(function(data) {
				processScorecardResponse(data);
				vm.loading = false;
			});
		} else {
			vm.hideEmail = false;
			vm.hideSupplierCode = false;
			scorecardServ.getScorecardData($scope.supplierNdxs, false, $scope.leanDirFactoryNdxs).then(function(data) {
				processScorecardResponse(data);
				vm.loading = false;
			});
		}
	}

	var w = angular.element($window);
	function getScoreCardWindowDimensions() {
		return {
			'w': Math.max(w.width(), window.innerWidth),
			'h': window.innerHeight
		};
	}

	$scope.$watch(getScoreCardWindowDimensions, function (newValue, oldValue) {
		if (oldValue.h !== newValue.h) {
			jQuery('.supplier-score-card-body').css('height', newValue.h - jQuery('.supplier-score-card-header').height() - 90);
		}
	}, true);

	init();
});
